<template>
  <div class="single__service">
    <salutation :salutation="booking.salutation" :surname="booking.surname"></salutation>

    <div class="simple-service__description">{{$t('simpleService.confirmation.titleDescription')}}</div>

    <div class="confirmation__termin--container">
      <div class="confirmation__termin--inner">
        <div class="confirmation__termin--left">
          {{$t('simpleService.confirmation.termin')}}:
        </div>
        <div>
          {{booking.dropoffFrom.time | moment('DD.MM.YYYY')}}
          {{booking.dropoffFrom.time | timeFilter}}
        </div>
      </div>
      <div class="confirmation__termin--inner">
        <div class="confirmation__termin--left">{{$t('simpleService.confirmation.services')}}:</div>
        <div>
          <div v-for="(service, index) in booking.services" v-bind:key="index">
            {{service}}
          </div>
        </div>
      </div>
    </div>

    <div class="simple-service__description">{{$t('simpleService.confirmation.longDescription')}}</div>

    <div class="simple-service__description">
      <div>{{$t('simpleService.confirmation.complimentaryClose')}}</div>
      <div>{{$t('simpleService.confirmation.signature')}}</div>
    </div>

    <div class="simple-service__description">
      <div>{{booking.locationName}}</div>
      <div>{{booking.locationAddress}}</div>
    </div>
  </div>
</template>

<script>
import Salutation from '@/modules/simpleService/components/Salutation';
import { mapGetters } from 'vuex';

export default {
  name: 'SimpleServiceBookingConfirm',
  computed: {
    ...mapGetters('offer', {
      booking: 'booking'
    })
  },
  components: {
    Salutation
  }
}
</script>
